import angular from 'angular';
import templateBlockComponent from './template-block.component';

let templateBlockModule = angular.module('template-block', [])

.component('templateBlock', templateBlockComponent)

.name;

export default templateBlockModule;



// WEBPACK FOOTER //
// ./client/app/components/template-block/template-block.js